import axios from "axios";
import Cookies from "js-cookie";
import { store } from "../redux/store";
import { logout } from "../redux/AuthSlice";



export const imageBaseUrl = 'https://api.vendispot231.online';

const axiosInstance = axios.create({
    // baseURL: 'http://192.168.1.37:2025',
    // baseURL: 'https://srrtfv11-2025.inc1.devtunnels.ms/',
    baseURL: 'https://api.vendispot231.online',
    headers: {
    'Content-Type': 'application/json',
},
});
// Attach token before every request
axiosInstance.interceptors.request.use(
    (config) => {
        const token = Cookies.get('vendispot_token') || localStorage.getItem('vendispot_token');

        console.log(token)
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config;
    },
    (error) => Promise.reject(error)
);

let isHandlingAuthFailure = false;

const clearSessionAndLogout = () => {
    Cookies.remove('vendispot_token');
    localStorage.removeItem('vendispot_token');
    localStorage.removeItem('vendispot_user');
    store.dispatch(logout());
};

const isTokenExpiredError = (error) => {
    const status = error?.response?.status;
    const message = (error?.response?.data?.message || error?.message || "").toLowerCase();

    if (status === 401) return true;
    return message.includes("token expired") || message.includes("jwt expired") || message.includes("invalid token");
};

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        const shouldForceLogout = isTokenExpiredError(error) && window.location.pathname !== "/login";

        if (shouldForceLogout && !isHandlingAuthFailure) {
            isHandlingAuthFailure = true;
            clearSessionAndLogout();
            window.location.href = "/login";
            setTimeout(() => {
                isHandlingAuthFailure = false;
            }, 1000);
        }

        return Promise.reject(error);
    }
);



export default axiosInstance
